import moment from 'moment';
import React from 'react';

interface ComponentProps {
  /** Date formatted as ISO string ("1970-01-19T13:44:50.306Z") */
  date?: string | null;
  dateFormat?: string;
}

const isNumber = (value: string) => /^\d+$/.test(value);

const convertToMilliSeconds = (date: string) => {
  switch (date.length) {
    case 10:
      return parseInt(date, 10) * 1000;
    case 13:
      return parseInt(date, 10);
    case 16:
      return parseInt(date, 10) / 1000;
    default:
      return 10000000000000000;
  }
};

const FormattedDate = ({ date, dateFormat }: ComponentProps) =>
  !date ? (
    <span />
  ) : (
    <span>
      {isNumber(date)
        ? moment.utc(convertToMilliSeconds(date)).format(dateFormat)
        : moment.utc(date).format(dateFormat)}
    </span>
  );

export default FormattedDate;
